import { environment } from "src/environments/environment";

export const ImageService = {
	removeBackground: async (data: FormData) => await fetch(`${environment.externalAPIs.photoroom.url}`, {body: data, headers: {"x-api-key": environment.externalAPIs.photoroom.apiKey}, method: "POST"}),
}